export class DistanceUnit {
    text: string
    distanceDescription: string
    value: string
    metres: number
    metricElevation: boolean
    constructor(text: string, distanceDescription: string, value: string, metres: number, metricElevation = true) {
        this.text = text
        this.distanceDescription = distanceDescription
        this.value = value
        this.metres = metres
        this.metricElevation = metricElevation
    }
}

export const feetPerMetre = 3.28084 
const metresPerMile = 1609.34
const metresPerKm = 1000

const DistanceUnits = [
    new DistanceUnit('Kilometres / metres', 'kilometres', 'km', metresPerKm),
    new DistanceUnit('Miles / feet', 'miles', 'mi', metresPerMile, false),
    new DistanceUnit('Miles / metres', 'miles', 'mim', metresPerMile)
]

export default DistanceUnits


